/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Userqueues1Inputs */

const en_entity_userqueues1 = /** @type {(inputs: Entity_Userqueues1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Queues`)
};

const de_entity_userqueues1 = /** @type {(inputs: Entity_Userqueues1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer-Queues`)
};

/**
* | output |
* | --- |
* | "User Queues" |
*
* @param {Entity_Userqueues1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_userqueues1 = /** @type {((inputs?: Entity_Userqueues1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Userqueues1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_userqueues1(inputs)
	return de_entity_userqueues1(inputs)
});
export { entity_userqueues1 as "entity_userQueues" }